module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "row margin-lateral-10 card"
  }, [_c('div', {
    staticClass: "row padding-10"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.fa_icon,
    staticStyle: {
      "margin-left": "-10px"
    }
  })]), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04f370aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/general_notification_components/BaseNotifications.vue
// module id = 769
// module chunks = 2